<template>
  <div class="flex">
    <div class="w-full relative">
      <label v-if="label" class="block text-sm text-white font-semibold">{{ label }}</label>

      <div class="relative">
        <select
            :multiple="multiple"
            v-model="item"
            :disabled="disabled"
            :class="[selectStyle, 'pr-8']"
        >
          <option disabled value="">{{ placeholder || 'انتخاب کنید' }}</option>

          <option
              v-for="option in items"
              :key="option.value"
              :value="option.value"
          >
            {{ option.name }}
          </option>
        </select>

        <button
            v-if="clearable && !disabled && hasCurrentValue"
            class="absolute left-0 inset-y-0 flex items-center pl-2 text-gray-500 hover:text-gray-700 text-xs"
            type="button"
            @click.stop="clearSelection"
        >
          ✕
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserSelect',
  props: {
    value: {},
    label: { default: null },
    selectStyle: {
      default: "px-3 py-2 bg-gray-300 text-sm rounded-lg border w-60 text-right"
    },
    placeholder: { default: null },
    disabled: { default: false },
    multiple: { default: false },
    userType: { default: 'stke' },
    clearable: { default: false }
  },

  data() {
    return {
      items: [],
      item: this.value || (this.multiple ? [] : '')
    };
  },

  computed: {
    hasCurrentValue() {
      if (this.multiple) {
        return Array.isArray(this.item) && this.item.length > 0;
      }
      return this.item !== '' && this.item !== null && this.item !== undefined;
    }
  },

  methods: {
    loadItems() {
      if (this.userType === 'stke') {
        this.getStorekeepers();
      } else if (this.userType === 'suad') {
        this.getSupplierAdmin();
      } else if (this.userType === 'buow') {
        this.getBusinessOwner();
      } else if (this.userType === 'paad') {
        this.getPackingAdmins();
      } else if (this.userType === 'prtnr') {
        this.getPartners();
      }
    },
    reload() {
      this.loadItems();
    },
    clearSelection() {
      this.item = this.multiple ? [] : '';
    },

    getPartners() { this.fetchItems('partner-stock/partners/all'); },
    getBusinessOwner() { this.fetchItems('main/businessOwner/all'); },
    getSupplierAdmin() { this.fetchItems('main/supplierAdmin/all'); },
    getStorekeepers() { this.fetchItems('main/storekeeper/all'); },
    getPackingAdmins() { this.fetchItems('main/packingAdmin/all'); },

    fetchItems(endpoint) {
      this.request({
        url: this.endpoint(endpoint),
        method: 'get',
        success: data => {
          this.items = data.map(item => ({
            name: `${item.first_name} ${item.last_name}`,
            value: item.id
          }));
        }
      });
    }
  },

  watch: {
    value(val) {
      this.item = val || (this.multiple ? [] : '');
    },
    item(val) {
      this.$emit('input', val);
    }
  },

  created() {
    this.loadItems()
  }
};
</script>
